<template lang="html">
    <div class="panel panel-default">
      <div class="panel-heading">
        Developer Tools
      </div>
      <div class="panel-body">
          <ul class="list-group developer-tools">
            <li class="list-group-item level jc-sb ai-c" v-if="isAdmin">
                <span>Maintenance Mode</span>
                <button type="button" class="btn btn-danger" @click="enableMaintenanceMode">
                    Enable
                </button>
            </li>
            <li class="list-group-item level jc-sb ai-c">
                <span>Application Cache</span>
                <button type="button" class="btn btn-warning" @click="clearApplicationCache">
                    Clear
                </button>
            </li>
            <li class="list-group-item level jc-sb ai-c" v-if="isAdmin">
                <span>Failed Queue</span>
                <button type="button" class="btn btn-default" @click="clearFailedQueueJobs">
                    Flush
                </button>
            </li>
            <li class="list-group-item level jc-sb ai-c" v-if="isAdmin">
                <span>Backup to S3</span>
                <button type="button" class="btn btn-default" @click="backupToCloud">
                    Backup
                </button>
            </li>
            <li class="list-group-item level jc-sb ai-c" v-if="isAdmin">
                <span>View Error Logs on Bugsnag</span>
                <a class="btn btn-default" href="https://app.bugsnag.com/found-sm/laravel/errors" target="_blank">Open</a>
            </li>
          </ul>
      </div>
    </div>
</template>

<script>
export default {
    computed: {
        isAdmin() {
            return Spark.state.user.id === 1;
        }
    },
    
    methods: {
        enableMaintenanceMode() {
            axios.get('/api/developer-tools/maintenance')
            .then(() => location.reload());
        },

        clearApplicationCache() {
            axios.get('/api/developer-tools/clear-app-cache')
            .then((response) => {
                Bus.$emit('show-success-alert', response.data.message);
            });
        },

        clearFailedQueueJobs() {
            axios.get('/api/developer-tools/clear-failed-queue')
            .then((response) => {
                Bus.$emit('show-success-alert', response.data.message);
            });
        },

        backupToCloud() {
            axios.get('/api/developer-tools/backup-to-cloud')
            .then((response) => {
                Bus.$emit('show-success-alert', response.data.message);
            });
        },
    }
}
</script>

<style scoped lang="sass">
    .developer-tools
        button, a.btn
            width: 85px
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/developer/DeveloperTools.vue